module.exports = __webpack_public_path__ + "assets/60a329af180f0aea56b886acfcdd3433.mp3";